import { WithdrawalAccounts } from 'modules/onboarding/common/components';

import { useWithdrawalAccounts } from '../hooks';
import { PageComponentProps } from '../types';

export const WithdrawalAccountsStep = ({ canGoBack }: PageComponentProps) => {
  const {
    countries,
    countriesLoading,
    initialValues,
    submitLoading,
    onSubmit,
    goToBack,
    files,
    onAddFiles,
    onRemoveFile,
  } = useWithdrawalAccounts();

  return (
    <WithdrawalAccounts
      canGoBack={canGoBack}
      countries={countries}
      countriesLoading={countriesLoading}
      files={files}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onAddFiles={onAddFiles}
      onGoBack={goToBack}
      onRemoveFile={onRemoveFile}
      onSubmit={onSubmit}
    />
  );
};
